const nortonContainer = document.querySelector('.Shopping-Guarantee-Product');

// Options for the observer (which mutations to observe)
const config = { attributes: true, childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    if (mutation.type === 'childList') {
     const nortonFacade = document.querySelector(".norton-badge__container")
      
       nortonFacade.addEventListener('click', () => {
         const nortonEl = document.querySelector(".Shopping-Guarantee-Product img")
         nortonEl.click()
       })
    } 
  }
};

document.addEventListener('DOMContentLoaded', function () {
  
    setTimeout(function () {
        const checkbox = document.querySelector('[name="filter.v.availability"][value="1"]');
        
        if (checkbox && !checkbox.checked) {
            checkbox.click(); 
           
        }
    }, 500); 
});